import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function GameCategories() {
  return (
    <section id="categories" className="w-full px-4 md:px-6 py-16 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
            丰富游戏分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            六大游戏类型，满足您的所有娱乐需求。从经典电子游戏到真人荷官，从体育竞技到电竞投注，总有一款适合您。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4" data-product-shop="">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-900 rounded-xl p-4 md:p-5 border border-background-700/30 hover:border-primary-500/30 transition-all duration-300 hover:translate-y-[-3px] text-center cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto flex items-center justify-center rounded-xl bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${cat.icon} text-primary-400 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-500 line-clamp-2">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}